import { useContext, useEffect, useState } from 'react'
import { ClientContext } from '../../../../contexts/clientProvider'
import DataTable from '../../../Table'
import LoadingSpinner from '../../../Loader/load'

const Patrimonios = ({ client, handleFecharClick}) => {
    const { getPatrimoniosByCliente } = useContext(ClientContext)
    const [dados, setDados] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        getDados()
    }, [])

    const getDados = async () => {
        if (dados.length > 0) return
        setLoading(true)
        let newDados = await getPatrimoniosByCliente(client.id)
        setLoading(false)
        setDados(newDados)
    }

    const headers = [
        { label: 'Anexo', key: 'nome_anexo', sortable: true },
        { label: 'Modelo', key: 'nome_modelo', sortable: false },
        { label: 'Patrimonio', key: 'nEtiqueta', sortable: false },
        { label: 'Mac', key: 'nMac', sortable: false },
        { label: 'Nome', key: 'nome', sortable: false },
        { label: 'Setor', key: 'setor', sortable: false },
        { label: 'Ramal', key: 'ramal', sortable: false },
    ]

    return (
        <div className="space-y-6">
            {/* Header com informações */}
            <div className="bg-white dark:bg-gray-800 rounded-lg p-4 shadow-sm border border-gray-200 dark:border-gray-700">
                <div className="flex items-center space-x-3 mb-4">
                    <span className="text-2xl">🏢</span>
                    <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
                        Patrimônios do Cliente
                    </h2>
                </div>
                <p className="text-gray-600 dark:text-gray-400">
                    Lista de todos os patrimônios associados a este cliente.
                </p>
            </div>

            {/* Tabela de dados */}
            {loading ? (
                <div className="flex items-center justify-center min-h-64">
                    <LoadingSpinner />
                </div>
            ) : (
                <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
                    <DataTable data={dados} headers={headers} itemsPerPage={5} />
                </div>
            )}

            {/* Botões de ação */}
            <div className="flex flex-col sm:flex-row gap-3 pt-6 border-t border-gray-200 dark:border-gray-700">
                <button 
                    onClick={handleFecharClick}
                    className="flex-1 sm:flex-none px-6 py-3 bg-gray-500 hover:bg-gray-600 text-white font-medium rounded-lg transition-colors duration-200 flex items-center justify-center"
                >
                    <span className="mr-2">✕</span>
                    Fechar
                </button>
            </div>
        </div>
    )
}

export default Patrimonios
